import HeaderTitle from './HeaderTitle.component';

export default HeaderTitle;
